module.exports = __webpack_public_path__ + "static/blueproton-99971fcc2ab5d582017c6572a84fca3b.png";